import React from 'react';

import { Layout } from '../components';
import { useStateContext } from '../contexts/ContextProvider';

  const ProtectedRoute = () => {
    const {user} = useStateContext();

    if (!user?.tenantInfo) {
      return <div className="flex flex-row h-screen items-center justify-center">
          <div className="h-[74px] w-[74px]">
            <gz-progress-spinner spinnerWidth="large" indeterminate />
          </div>
        </div>
    }
  
    return <Layout />;
  };

export default ProtectedRoute;